import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaCheckCircle, FaArrowRight } from "react-icons/fa";
import MyPage from "./MyPage";

function AboutUs() {
 const [about, setAbout] = useState({
  titleIcon: "",
  sectionTitle: "",
  heading: "",
  description: "",
  features: [],
  images: { top: "", bottom: "" },
  button: { text: "", link: "" }
});

  /* ===== SCROLL ANIMATION ===== */
  useEffect(() => {
    const section = document.querySelector(".about-section");

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          section.classList.add("in-view");
        }
      },
      { threshold: 0.3 }
    );

    if (section) observer.observe(section);
  }, []);

  /* ===== JSON + XML (SAME PATTERN AS OTHERS) ===== */
  useEffect(() => {
    // ✅ JSON (UI)
    fetch("/api/about.json")
      .then(res => res.json())
      .then(data => setAbout(data));

    // ✅ XML (exam / proof)
    fetch("/api/about.xml")
      .then(res => res.text())
      .then(() => console.log("About XML loaded"));
  }, []);


  return (
    <>
    <MyPage
        title="AboutUs | Thrissur Jilla Pravasi Koottyama"
        description="Thrissur Pravasi families united through community engagement and social welfare."
        keywords="Thrissur Pravasi, Community Engagement, Pravasi Activities"
      />
      <section className="about-section">
        <div className="about-content about-reveal-left">
          <h6 className="section-title">
            <img src={about.titleIcon} alt="" />
            {about.sectionTitle}
          </h6>

          <h2 className="welcome-text">{about.heading}</h2>

          <p>
            <strong>Thrissur Jilla Pravasi Koottyama </strong>
            {about.description}
          </p>

          <ul className="about-list about-stagger">
            {about.features.map((item, index) => (
              <li key={index}>
                <FaCheckCircle /> {item}
              </li>
            ))}
          </ul>

          <Link to={about.button.link} className="btn-watch-videos">
            {about.button.text} <FaArrowRight />
          </Link>
        </div>

        <div className="about-images about-reveal-right">
          <img src={about.images.top} className="img-top" alt="" />
          <img src={about.images.bottom} className="img-bottom" alt="" />
        </div>
      </section>

      {/* ===== ABOUT US CSS + ANIMATION ===== */}
      <style>{`
/* LAYOUT */
.about-section {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  align-items: center;
  padding: 21px 53px;
  max-width: 1400px;
  margin: 0 auto;
}

/* TITLES */
.section-title {
  font-size: 25px;
  font-weight: 700;
  color: #222;
  margin-bottom: 18px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.welcome-text {
  color: var(--primary-color);
  font-size: 28px;
  margin-bottom: 20px;
}

/* CONTENT */
.about-content p {
  font-size: 17px;
  line-height: 1.6;
  margin-bottom: 25px;
}

/* LIST */
.about-list {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 35px;
  padding: 0;
}

.about-list li {
  display: flex;
  align-items: center;
  gap: 6px;
}

/* BUTTON */
.discover-btn {
  display: inline-block;
  padding: 17px 22px;
  background: var(--primary-color);
  border-radius: 6px;
  font-weight: 700;
  text-decoration: none;
  transition: 0.4s;
}

.discover-btn:hover {
  transform: translateY(-3px) scale(1.05);
}

/* IMAGES */
.about-images {
  position: relative;
}

.img-top {
  width: 100%;
  border-radius: 8px;
}

.img-bottom {
  position: absolute;
  bottom: -21px;
  left: -59px;
  width: 67%;
  border-radius: 8px;
}

/* ================= ANIMATIONS ================= */

/* INITIAL */
.about-reveal-left,
.about-reveal-right,
.about-btn-animate {
  opacity: 0;
  transition: all 1s ease;
}

.about-reveal-left {
  transform: translateX(-80px);
}

.about-reveal-right {
  transform: translateX(80px) scale(0.95);
}

/* ACTIVE */
.about-section.in-view .about-reveal-left,
.about-section.in-view .about-reveal-right,
.about-section.in-view .about-btn-animate {
  opacity: 1;
  transform: translateX(0) scale(1);
}

/* LIST STAGGER */
.about-stagger li {
  opacity: 0;
  transform: translateY(25px);
}

.about-section.in-view .about-stagger li {
  animation: listFadeUp 0.6s ease forwards;
}

.about-section.in-view .about-stagger li:nth-child(1){animation-delay:0.1s;}
.about-section.in-view .about-stagger li:nth-child(2){animation-delay:0.2s;}
.about-section.in-view .about-stagger li:nth-child(3){animation-delay:0.3s;}
.about-section.in-view .about-stagger li:nth-child(4){animation-delay:0.4s;}
.about-section.in-view .about-stagger li:nth-child(5){animation-delay:0.5s;}
.about-section.in-view .about-stagger li:nth-child(6){animation-delay:0.6s;}

@keyframes listFadeUp {
  from { opacity: 0; transform: translateY(25px); }
  to { opacity: 1; transform: translateY(0); }
}

/* RESPONSIVE */
@media (max-width: 992px) {
  .about-section {
    grid-template-columns: 1fr;
    padding: 24px;
  }

  .img-bottom {
    position: static;
    width: 100%;
    margin-top: 20px;
  }
}
      `}</style>
    </>
  );
}

export default AboutUs;
